import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SafeResourceUrlPipe } from '../../pipes/safe-resource-url.pipe';

@Component({
  selector: 'app-campaign-details',
  standalone: true,
  imports: [CommonModule, SafeResourceUrlPipe],
  templateUrl: './campaign-details.component.html',
  styleUrl: './campaign-details.component.css'
})
export class CampaignDetailsComponent implements OnInit {
  resource: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    // Get the resource passed securely via router state
    const navigation = this.router.getCurrentNavigation();
    this.resource = navigation?.extras.state?.['item'];
  }

  ngOnInit(): void {
    if (!this.resource) {
      // Future Drupal integration: if user loads this URL directly (no state),
      // we would fetch the article by ID from the backend API here.
      const id = this.route.snapshot.paramMap.get('id');
      console.log('Fetching campaign resource ID:', id);
    }
  }

  goBack(): void {
    this.location.back();
  }
}
